import { SHA1 } from "crypto-js";
import toString from "lodash/toString";

export function encodeToSha1(value: string) {
  return toString(SHA1(value));
}
